import {
    NgModule
} from '@angular/core';
import {
    PlaceMapViewComponentModule
} from '../custom_component/PlaceMapView/PlaceMapView.module';
import {
    PlaceKeyInfoCardComponentModule
} from '../custom_component/PlaceKeyInfoCard/PlaceKeyInfoCard.module';
import {
    FeedCardComponentModule
} from '../custom_component/FeedCard/FeedCard.module';
import {
    PlaceCardComponentModule
} from '../custom_component/PlaceCard/PlaceCard.module';
import {
    MainMenuComponentModule
} from '../custom_component/MainMenu/MainMenu.module';
import {
    PhoneInputComponentModule
} from '../custom_component/PhoneInput/PhoneInput.module';
import {
    AlbumItemComponentModule
} from '../custom_component/AlbumItem/AlbumItem.module';
@NgModule({
    declarations: [],
    exports: [
        PlaceMapViewComponentModule,
        PlaceKeyInfoCardComponentModule,
        FeedCardComponentModule,
        PlaceCardComponentModule,
        MainMenuComponentModule,
        PhoneInputComponentModule,
        AlbumItemComponentModule,
    ],
    imports: []
})
export class CustomComponentsModule {}